import { DEFAULT_DOMAIN } from 'app/App';
import { EXPRESS_API } from 'configs/api/expressApi';
import { WHITELABEL_NAME } from 'lib/api/whitelabel/getWhiteLabel';
import { THEME_NAME, useAuth } from 'lib/context';
import { useEffect } from 'react';

const CDK_REDIRECT_URL =
  'https://connectcdk.okta.com/app/connectcdk_crmvideo_1/exk15qbrtueF6zPG91t8/sso/saml?RelayState=https://api.covideo.com/sp/acs/cdk/admin';

export const useGlobalAxiosErrorHandler = () => {
  const { whitelabel, themeName } = useAuth();

  useEffect(() => {
    const redirectParam =
      whitelabel?.name === WHITELABEL_NAME.COVIDEO
        ? `?redirect=${window.location.toString()}`
        : '';

    const interceptor = EXPRESS_API.interceptors.response.use(
      res => res,
      err => {
        const status = err.response?.status;
        if (status === 401 && themeName === THEME_NAME.CDK) {
          window.location.href = CDK_REDIRECT_URL;
          return;
        }
        if (status === 401) {
          window.location.href = `https://${whitelabel?.domainV2 || DEFAULT_DOMAIN}/backoffice/incs/logout.php${redirectParam}`;
        }

        return Promise.reject(err);
      }
    );

    return () => {
      EXPRESS_API.interceptors.response.eject(interceptor);
    };
  }, [whitelabel]);
};
